// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../react-scripts/node_modules/css-loader/index.js!../../../../less-loader/index.js!./component-detail.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../node_modules/style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../react-scripts/node_modules/css-loader/index.js!../../../../less-loader/index.js!./component-detail.less", function() {
			var newContent = require("!!../../../../react-scripts/node_modules/css-loader/index.js!../../../../less-loader/index.js!./component-detail.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/style-loader!/opt/atlassian/pipelines/agent/build/~/react-scripts/~/css-loader!/opt/atlassian/pipelines/agent/build/~/less-loader!./src/css/component-detail.less
// module id = 380
// module chunks = 0